import { useTheme } from "@quales/utils/theme";
import React from "react";
import Link from "@mui/material/Link";
import { WcList, WcListItem, WcStack, WcTypography } from "@bpipartners/webui";

interface FormIndexComponentProps {
  data: any;
  errorIndexes: string[];
}

export const FormIndexComponent = (props: FormIndexComponentProps) => {
  const { data, errorIndexes } = props;
  const [selectedIndexItem, setSelectedIndexItem] = React.useState<
    number | undefined
  >(0);
  const theme = useTheme();
  const handleOnClick = (item: any) => {
    const getObjectIndex = data.uiSchema["ui:order"].findIndex(
      (itm: any) => itm === item
    );
    setSelectedIndexItem(getObjectIndex);
  };

  const getActiveColor = (index: number): string =>
    index === selectedIndexItem
      ? theme.appColors.secondary
      : theme.appColors.primary;

  return (
    <WcStack id="FormIndexComponent" height={"auto"}>
      <WcList
        sx={{
          marginTop: 4,
          padding: 2,
        }}
      >
        {data.uiSchema["ui:order"].map((item: any, index) => {
          if (
            data.formSchema.properties[item] &&
            data.formSchema.properties[item].type === "object"
          ) {
            return (
              <WcListItem
                sx={{
                  width: 240,
                  cursor: "pointer",
                  borderRadius: 50,
                  padding: 2,
                  margin: 2,
                }}
                onClick={() => handleOnClick(item)}
                key={index}
              >
                <Link
                  href={`#${data.formSchema.properties[item].title}`}
                  underline="none"
                  color={getActiveColor(index)}
                  sx={{
                    ":hover": {
                      color: theme.appColors.secondary,
                    },
                  }}
                >
                  <WcTypography variant="caption" pl={5}>
                    {data.formSchema.properties[item].title}
                  </WcTypography>
                </Link>

                {errorIndexes && errorIndexes.length > 0 && (
                  <WcTypography
                    ml={1}
                    color={
                      errorIndexes.includes(item) ? theme.appColors.error : ""
                    }
                    fontSize={10}
                  >
                    {errorIndexes.includes(item) ? " (Errors)" : ""}
                  </WcTypography>
                )}
              </WcListItem>
            );
          }
        })}
      </WcList>
    </WcStack>
  );
};

export default FormIndexComponent;
